const s = {
  name: "Angry",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M13,30c0-3.9,3.1-7,7-7s7,3.1,7,7h2c0-5-4-9-9-9s-9,4-9,9H13z"/>
<path class="st0" d="M15.6,19.9l-7.7-3l0.7-1.9l7.7,3L15.6,19.9z"/>
<path class="st0" d="M24.4,19.9l7.7-3l-0.7-1.9l-7.7,3L24.4,19.9z"/>
<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0z M2,20c0-9.9,8.1-18,18-18
	c9.9,0,18,8.1,18,18c0,9.9-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
</svg>
  `
};
export {
  s as Angry
};
